import { Link } from 'expo-router';
import React from 'react';
import { StyleSheet } from 'react-native';

import { Text, tokens } from '@fhs/ui';

const FIREHOUSE_INSIDERS_PROGRAM_NAME = 'Firehouse Subs Insiders';
const FIREHOUSE_INSIDERS_INFO_URL = '/firehouse-subs-insiders?source=sign-up';

export const PromotionalEmailsLabel = () => {
  return (
    <Text testID={'opt-in-label-acceptEmailsAndSpecialOffers'} style={styles.label}>
      I want to receive special offers and other information from Firehouse Subs®
    </Text>
  );
};

export const FirehouseInsidersLabel = () => {
  return (
    <Text testID={'opt-in-label-firehouse-insiders'} style={styles.label}>
      I want to join{' '}
      <Link href={FIREHOUSE_INSIDERS_INFO_URL} style={styles.link}>
        {FIREHOUSE_INSIDERS_PROGRAM_NAME}
      </Link>{' '}
      and consent to receiving occasional invites to surveys or focus groups via email
    </Text>
  );
};

export const TermsOfServiceLabel = ({ error = false }: { error: boolean }) => {
  const privacyPolicyLink = (
    <Link href="/privacy-policy" style={styles.link}>
      Privacy Policy
    </Link>
  );

  const rewardsPolicyLink = (
    <Link href="/terms-conditions-rewards" style={styles.link}>
      Firehouse Rewards Terms
    </Link>
  );

  const termsOfServiceLink = (
    <Link href="/terms-of-service" style={styles.link}>
      Terms of Service
    </Link>
  );

  return (
    <Text style={[styles.label, error && styles.errorLink]}>
      By checking this box, you acknowledge that you have read and agree to our {termsOfServiceLink}{' '}
      including the mandatory arbitration clause, {privacyPolicyLink} and {rewardsPolicyLink}
    </Text>
  );
};

const styles = StyleSheet.create({
  label: {
    fontSize: 14,
    lineHeight: 19.6,
  },
  link: {
    color: tokens.colors.$houseRedDarken,
    textDecorationLine: 'underline',
  },
  errorLink: {
    color: tokens.colors.$houseRedDarken,
  },
});
